import React from 'react';
import { Checkbox, Colors } from 'shared/components/ui/checkbox';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './popup-menu.style';

export type PopupMenuCheckboxProps = {
  label: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
  id?: string;
  level?: number;
  compact?: boolean;
  color?: Colors | string;
  dimmed?: boolean;
  children?: React.ReactNode;
};

export const PopupMenuCheckbox: React.FC<PopupMenuCheckboxProps> = ({
  label,
  checked,
  onChange,
  id = uuidv4(),
  level,
  compact,
  color,
  dimmed,
  children,
}) => {
  const _onChange = () => onChange(!checked);

  return (
    <Styled.CheckboxContainer
      htmlFor={id}
      $level={level}
      $compact={!!compact}
      $dimmed={dimmed}
    >
      <Checkbox
        value=""
        id={id}
        checked={checked}
        onChange={_onChange}
        color={color}
      />
      <Styled.CheckboxLabel>{label}</Styled.CheckboxLabel>
      {children}
    </Styled.CheckboxContainer>
  );
};
